import { PlanningType } from "@eisox/api/core-api";
import { Switch } from "@eisox/design-system";
import { ArrowRightIcon } from "@eisox/icons";

import { PlanningTypeKey, type PlanningType as PlanningTypeKeyType } from "~/features/planning";
import { m } from "~/paraglide/messages";

interface TimeslotProps {
  text: string;
  planningType: PlanningTypeKeyType;
  temperature?: number;
}

const Timeslot: React.FC<TimeslotProps> = ({ text, planningType, temperature }) => (
  <div className="md:flex-col flex flex-row items-center gap-[10px]">
    <p className="font-normal text-justify text-base leading-[21px]">{text}</p>
    <ArrowRightIcon className="md:rotate-90" />
    <PlanningTypeKey className="mt-px h-[21px] !text-primary-dark-blue" type={planningType} temperature={temperature} />
  </div>
);

interface PreComfortTimeslotGenerationProps {
  activate?: boolean;
  absenceTemperature: number;
  preComfortTemperature?: number;
  comfortTemperature?: number;
}

export const PreComfortTimeslotGeneration: React.FC<PreComfortTimeslotGenerationProps> = ({
  activate = false,
  absenceTemperature,
  preComfortTemperature,
  comfortTemperature,
}) => (
  <div className="w-full">
    <label className="font-medium mb-[10px] flex items-center text-base leading-[21px]">
      <Switch className="mr-[6px] cursor-default" checked={activate} onCheckedChange={() => {}} />
      {m.pre_comfort_timeslot_generation()} {m.activation({ activation: activate ? "true" : "false" }).toLowerCase()}
    </label>
    <div className="gap-5 md:flex-row flex flex-col justify-center">
      <Timeslot text={m.no_presence_habit()} planningType={PlanningType.ABSENCE} temperature={absenceTemperature} />
      {activate && (
        <Timeslot
          text={m.irregular_presence_habit()}
          planningType={PlanningType.PRE_COMFORT}
          temperature={preComfortTemperature}
        />
      )}
      <Timeslot text={m.presence_habit()} planningType={PlanningType.COMFORT} temperature={comfortTemperature} />
    </div>
  </div>
);

PreComfortTimeslotGeneration.displayName = "PreComfortTimeslotGeneration";
